<!-- 
    button按钮 
    author:xxk 
    https://element.eleme.cn/#/zh-CN/component/button
 -->
<template>
  <el-button class="AppButton-root" :style="styles" v-bind="buttonPropsResult"  @click="$emit('click',$event)">
    <!-- 各插槽中转 -->
    <template v-for="name in Object.keys($slots)" #[name]>
      <slot :name="name"></slot>
    </template>
  </el-button>
</template>
<script>
  export default {
    name: 'AppButton',
    props: {
      // 组件属性
      buttonProps: { type: Object, default() { return {}; } },
      // 样式
      styles: { type: Object, default() { return {}; } },
      // 按钮类型
      btnType:{ type: String, default() { return ''; } }
    },
    computed:{  
      // 组件属性合并结果
      buttonPropsResult(){
        return Object.assign(
          {
            type:'primary',
            size:'small',
          },
          this.$attrs,
          this.buttonProps,
        );
      }
    },
  };
</script>
<style scoped lang="less">
    .AppButton-root{ 
      &.el-button+.el-button{ margin-left: 0;}
      &.el-button--medium{ height: auto;  }
    }
</style>
